import { mapMutations } from 'vuex'
import { s3 } from '@/wrapper/s3'
import apxAlert from '@/wrapper/apex-alert'
export default {
  methods: {
    ...mapMutations('errors', ['SET_ERROR']),
    async getDownUrl (fileKey, originFileName) {
      try {
        var tag = document.createElement('a')
        tag.href = await s3.down(fileKey, originFileName)
        tag.click()
      } catch (err) {
        this.SET_ERROR(err)
        apxAlert.error('', '다운로드에 실패하였습니다.다시 시도해주세요')
      }
    }
  }
}
